import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

class DialogError extends Component {
    shouldComponentUpdate = (nextProps, nextState) => {
        return (!!this.props.message !== !!nextProps.message);
    }

    render = () => {
        return (
            <div>
                <Dialog
                    fullWidth={true}
                    disableBackdropClick={true}
                    disableEscapeKeyDown={true}
                    open={!!this.props.message}
                >
                    <DialogTitle>
                        {this.props.title}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {this.props.message}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color='secondary'
                            autoFocus={true}
                            onClick={this._handleOk}
                        >
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

    _handleOk = () => {
        if (this.props.onOk) {
            this.props.onOk(this.props.value);
        }
    }
}

DialogError.propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    onOk: PropTypes.func.isRequired,
}

export default DialogError;
